import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from '../constants/Config';
import User from '../models/User';
import Role from '../models/Role';

export function getUsers(params) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_LIST,
        params: params,
        parser: usersDataParser,
    }).get();
}

export function getUserDetail(id) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_DETAIL,
        endpointParams: { id },
        parser: data => new User(data.data),
    }).get();
}

export function createUser(user, password) {
    const payload = user.export();
    if (password) {
        payload.password = password;
    }
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_CREATE,
    }).post(payload);
}

export function updateUser(user) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_UPDATE,
        endpointParams: { id: user.id },
    }).put(user.export());
}

export function updateForceMfa(id, forceMfa) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_FORCE_MFA,
        endpointParams: { id },
    }).put({ forceMfa });
}

export function deleteUser(id) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_DELETE,
        endpointParams: { id },
    }).delete();
}

export function changePassword(oldPassword, newPassword) {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.UPDATE_PASSWORD,
    }).post({ oldPassword, newPassword });
}

export function getUserRole() {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_ROLE,
        parser: data => (data.data || []).map(item => new Role(item)),
    }).get();
}

export function getCSUsers() {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_CS_USER_LIST,
        parser: data => (data.data || []).map(item => new User(item)),
    }).get();
}

export function getCustomerUser() {
    return new ApiService({
        baseURL: Config.API_IDENTITY,
        endpoint: Urls.USER_CUSTOMER_USER_LIST,
        parser: data => (data.data || []).map(item => new User(item)),
    }).get();
}

function usersDataParser(data = {}) {
    return {
        ...data,
        result: (data.result || []).map(item => new User(item))
    }
}
